import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import * as commonApi from '../../api/app/commonApi';
import * as api from '../../api/app/monitoredCounterScrapApi';
import { AssetFullPathHeader } from '../../components/core/AssetFullPathHeader/AssetFullPathHeader';
import { Loader } from '../../components/core/Loader/Loader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { AssetDetailTabValues, MonitoredPanelValues } from '../../types/app/asset.types';
import { MonitoredCounterScrapInputs } from '../../types/app/monitoredCounterScrap.types';
import { dictionary } from '../../utils/core/dictionary';
import { paths } from '../../utils/core/routes';
import { MonitoredCounterScrapForm } from './MonitoredCounterScrapForm';
import { useStyles } from './MonitoredCounterScrapForm.styles';

export function MonitoredCounterScrapCreate() {
  const { data: isUsedHydra } = useQuery<boolean>('useHydra', commonApi.useHydraDataService);
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { parentId } = useParams();

  const { mutate: mutateCreateMonitoredCounterScrap } = useMutation(
    api.createMonitoredCounterScrap,
  );

  const handleOnSubmit: SubmitHandler<MonitoredCounterScrapInputs> = (
    data: MonitoredCounterScrapInputs,
  ) => {
    data.parentAssetId = Number(parentId);
    if (data.useMultipleWithHydraPartitioning === undefined)
      data.useMultipleWithHydraPartitioning = false;
    mutateCreateMonitoredCounterScrap(
      { ...data },
      {
        onSuccess: () => {
          enqueueSnackbar(dictionary.MONITORED_COUNTER_SCRAP_CREATED, { variant: 'success' });
          navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
            state: {
              tabValue: AssetDetailTabValues.MONITORED_VALUES,
              panelValue: MonitoredPanelValues.MONITORED_COUNTER_SCRAP,
            },
          });
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  if (isUsedHydra === undefined) return <Loader />;
  return (
    <>
      <AssetFullPathHeader
        finalTitle={dictionary.MONITORED_COUNTER_SCRAP_CREATE}
        parentId={Number(parentId)}
      />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <MonitoredCounterScrapForm
                onSubmit={handleOnSubmit}
                isUsedHydra={isUsedHydra}
                onBack={() =>
                  navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
                    state: {
                      tabValue: AssetDetailTabValues.MONITORED_VALUES,
                      panelValue: MonitoredPanelValues.MONITORED_COUNTER_SCRAP,
                    },
                  })
                }
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
